import PropTypes from 'prop-types';
import React from 'react';

import { CLIENT_ROOT } from 'src/constants/paths';
import useTabs from 'src/hooks/useTabs';

import styles from './PlatformLink.module.scss';

const PlatformLink = ({ patient, patientId }) => {
  const { onSelectTab } = useTabs();
  const resolvedPatientId = patient?.id ?? patient?.patientId ?? patientId;
  const profileHref =
    resolvedPatientId != null ? `${CLIENT_ROOT}/patients/details/${resolvedPatientId}/info` : null;
  const hasLink = Boolean(profileHref);
  const displayMrn = patient?.mrn ?? (resolvedPatientId != null ? String(resolvedPatientId) : '—');

  return (
    <button
      type="button"
      className={`${styles.link} ${hasLink ? '' : styles.disabled}`}
      aria-disabled={!hasLink}
      onClick={() => {
        if (!hasLink) return;
        onSelectTab({ path: profileHref });
      }}
    >
      <div className={styles.badge}>
        <span className={styles.badgeText}>M</span>
      </div>
      <div className={styles.meta}>
        <span className={styles.title}>Open in Platform</span>
        <span className={styles.mrn}>{displayMrn}</span>
      </div>
      <span className={styles.arrow} aria-hidden="true">
        ↗
      </span>
    </button>
  );
};

PlatformLink.propTypes = {
  patient: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    mrn: PropTypes.string,
  }),
  patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PlatformLink;
